import React from "react";

export default function Preloader() {
  return <div className="loader" />;
}
